var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasLogo
        ? _c("img", {
            staticClass: "team-logo",
            attrs: { height: _vm.height, width: _vm.width, src: _vm.teamLogo }
          })
        : _c("placeholder-avatar", {
            attrs: {
              initials: _vm.initials,
              height: _vm.height,
              width: _vm.width
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }